/**
 * This indicates the version of the messaging interface.
 * This can help avoid having different messaging versions between the Satellite & SatelliteClient.
 */
export const messageVersion = 'application/x-satellite-v1+json';
/**
 * This indicates the message event whenever the parent or guest application receives as a result of postMessage.
 */
export const EVENT_NAME_MESSAGE = 'message';
/**
 * Supported modes of embedding web content by the library.
 */
export const SatelliteModes = {
    IFRAME: 'Iframe',
    SERVICE_WORKER_CLIENT: 'ServiceWorkerClient',
};
/**
 * Load event name for iFrame.
 */
export const IFRAME_LOAD_EVENT = 'load';
//# sourceMappingURL=Constants.js.map